enum SourceType {
	git = "Git",

	gitLab = "GitLab",
	gitHub = "GitHub",
	gitVerse = "GitVerse",

	confluenceCloud = "Confluence Cloud",
	confluenceServer = "Confluence self-hosted server",

	notion = "Notion",
}

export default SourceType;
